var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "quiz-form" },
    [
      !_vm.isPreviewQuiz
        ? _c(
            "CustomModal",
            {
              staticClass: "basic-modal quiz-form-modal",
              attrs: { id: "quiz-form-modal", isCustomFooter: true }
            },
            [
              _c(
                "div",
                {
                  staticClass: "new-quiz-title",
                  attrs: { slot: "modal-header" },
                  slot: "modal-header"
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm.isNewQuiz
                          ? "데일리 퀴즈 만들기"
                          : "데일리 퀴즈 수정하기"
                      ) +
                      "\n    "
                  )
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "new-quiz-body" }, [
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c(
                      "h6",
                      {
                        staticClass:
                          "typography--body-1 typography--color-secondary"
                      },
                      [
                        _c("strong", [
                          _vm._v("\n            퀴즈타입 선택\n          ")
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _vm._l(_vm.quizTypes, function(quiz, index) {
                      return _c(
                        "Radio",
                        {
                          key: index,
                          attrs: {
                            "model-value": _vm.selectedQuizType,
                            "check-value": index,
                            id: "quiz-type-" + index
                          },
                          on: {
                            change: function($event) {
                              return _vm.handleQuizTypeChange(index)
                            }
                          }
                        },
                        [
                          _c(
                            "span",
                            { attrs: { slot: "label" }, slot: "label" },
                            [_vm._v(_vm._s(quiz.name))]
                          )
                        ]
                      )
                    })
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c(
                      "h6",
                      {
                        staticClass:
                          "typography--body-1 typography--color-secondary"
                      },
                      [
                        _c("strong", [
                          _vm._v("\n            태그 선택\n          ")
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "typography--body-3 typography--color-disabled mb-8"
                      },
                      [
                        _vm._v(
                          "\n          최대 2개까지 선택 가능합니다.\n        "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _vm._l(_vm.tags, function(value, index) {
                      return _c(
                        "div",
                        {
                          key: index,
                          staticClass: "tag",
                          class: { selected: _vm.isSelectedTag(value) },
                          on: {
                            click: function($event) {
                              return _vm.handleTagClick(value)
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s("#" + value.name) +
                              "\n        "
                          )
                        ]
                      )
                    })
                  ],
                  2
                ),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c(
                    "h6",
                    {
                      staticClass:
                        "typography--body-1 typography--color-secondary"
                    },
                    [
                      _c("strong", [
                        _vm._v("\n            문제 입력\n          ")
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "field-wrapper" }, [
                    _c(
                      "div",
                      { staticClass: "textarea-wrapper w-100" },
                      [
                        _c("AutosizeTextarea", {
                          attrs: {
                            placeholder: "문제를 입력해주세요.",
                            limit: 40
                          },
                          model: {
                            value: _vm.content,
                            callback: function($$v) {
                              _vm.content = $$v
                            },
                            expression: "content"
                          }
                        })
                      ],
                      1
                    )
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c(
                      "h6",
                      {
                        staticClass:
                          "typography--body-1 typography--color-secondary"
                      },
                      [
                        _c("strong", [
                          _vm._v("\n            보기 입력\n          ")
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _vm._l(_vm.options, function(option, index) {
                      return _c(
                        "div",
                        { key: index, staticClass: "field-wrapper" },
                        [
                          _c(
                            "div",
                            { staticClass: "textarea-wrapper" },
                            [
                              _c("AutosizeTextarea", {
                                attrs: {
                                  isDisabled: _vm.isNoOptionsQuiz(_vm.options),
                                  placeholder: _vm.$t(
                                    "page_editor.choices.placeholder"
                                  ),
                                  limit: 10
                                },
                                model: {
                                  value: option.value,
                                  callback: function($$v) {
                                    _vm.$set(option, "value", $$v)
                                  },
                                  expression: "option.value"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "option-wrapper float-right" },
                            [
                              _c(
                                "Radio",
                                {
                                  attrs: {
                                    "model-value": _vm.selectedOption,
                                    "check-value": index,
                                    id: "option-" + index,
                                    "left-label": "true"
                                  },
                                  on: {
                                    change: function($event) {
                                      return _vm.handleOptionChange(option.key)
                                    }
                                  }
                                },
                                [
                                  false
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "typography--body-3 typography--color-secondary",
                                          attrs: { slot: "left-label" },
                                          slot: "left-label"
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm.$t(
                                                  "page_editor.choices.is_correct"
                                                )
                                              ) +
                                              "\n              "
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      )
                    })
                  ],
                  2
                ),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c(
                    "h6",
                    {
                      staticClass:
                        "typography--body-1 typography--color-secondary"
                    },
                    [
                      _c("strong", [
                        _vm._v("\n            문제 해설\n          ")
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "field-wrapper" }, [
                    _c(
                      "div",
                      { staticClass: "textarea-wrapper w-100" },
                      [
                        _c("AutosizeTextarea", {
                          attrs: {
                            placeholder: "해설을 입력해주세요.",
                            limit: 40
                          },
                          model: {
                            value: _vm.answer,
                            callback: function($$v) {
                              _vm.answer = $$v
                            },
                            expression: "answer"
                          }
                        })
                      ],
                      1
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { attrs: { slot: "modal-footer" }, slot: "modal-footer" },
                [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-secondary",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          return _vm.$emit("cancel")
                        }
                      }
                    },
                    [_vm._v("\n        취소\n      ")]
                  ),
                  _vm._v(" "),
                  _vm.isNewQuiz
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn-secondary",
                          attrs: { type: "button" },
                          on: { click: _vm.handlePreviewQuizClick }
                        },
                        [_vm._v("\n        미리보기\n      ")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isNewQuiz
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn-primary",
                          attrs: {
                            type: "button",
                            disabled: _vm.isDisabledQuiz
                          },
                          on: { click: _vm.handleNewQuizClick }
                        },
                        [
                          !_vm.isLoading
                            ? [_vm._v("저장")]
                            : _c("LoadingBounce")
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.isNewQuiz
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn-secondary",
                          attrs: {
                            type: "button",
                            disabled: _vm.isDisabledQuiz
                          },
                          on: { click: _vm.handleUpdateQuizClick }
                        },
                        [_vm._v("\n        수정\n      ")]
                      )
                    : _vm._e()
                ]
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isPreviewQuiz
        ? _c(
            "CustomModal",
            {
              staticClass: "basic-modal quiz-preview-modal",
              attrs: { id: "quiz-preview-modal", isHideFooter: true }
            },
            [
              _c(
                "div",
                {
                  staticClass: "quiz-preview-title",
                  attrs: { slot: "modal-header" },
                  on: { click: _vm.handlePreviewCloseClick },
                  slot: "modal-header"
                },
                [
                  _c("img", {
                    staticClass: "back-icon",
                    attrs: { src: "/static/images/ic-arrow-back.svg" }
                  }),
                  _vm._v("\n      미리보기\n    ")
                ]
              ),
              _vm._v(" "),
              _c("QuizPreview", { attrs: { quiz: _vm.getPreviewQuizData } })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0aec22c1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0aec22c1","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/my-quizzes/components/QuizFormModal.vue
// module id = MUYf
// module chunks = 1